import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Card } from '@clari/ui'

export function TransferSuccess() {
  const { t } = useTranslation('banking')
  const navigate = useNavigate()
  const location = useLocation()
  const name = (location.state as { name?: string } | null)?.name ?? ''

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <h1 className="text-2xl font-semibold">{t('transfer.success_title')}</h1>
        <p className="mt-2 text-text-muted">{t('transfer.success_body', { name })}</p>
        <Button className="mt-6" onClick={() => navigate('/app')}>
          {t('transfer.back_to_dashboard')}
        </Button>
      </Card>
    </div>
  )
}
